import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import _ from 'lodash';
import {
    getNayoseList,
    changeCurrentPath,
    resetMainListState,
    resetConsigneeListStateNew,
    getJigyoshaList,
    setNayoseList,
    resetMasterNayose,
    fetchCsvMasterNayose
} from '../../../actions';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import MainButtons from '../../../common/components/main-buttons';

import MasterTable from '../../../common/components/table/master-table';
import AlertDialog from '../../../common/components/dialog/alert-dialog';

const styles = theme => ({
    buttonHide:{
        position:'absolute',
        top:0,
        backgroundColor:'#FFFFFF',
        height:'100%',
        zIndex:6,
    },
    buttonHideLeft:{
        left:-20,
        width:20
    },
    buttonHideRight:{
        right:-100,
        width:100
    },
    cautionText:{
        marginTop:-20,
        color:'#f90c0c'
    }
});

let columns = [
    { name: 'JigyoushaCD_Obj', title: '事業者コード(受領拠点)' ,width:300, maxLength:10,validations:["required"]},
    { name: 'MakerCD_Obj', title: 'メーカーコード' ,width:300, maxLength:10,validations:["required"]},
    { name: 'NohinsakiCD', title: '納品先CD',width:350 ,maxLength:20,defaultValue:'',validations:["required"]},
];

let suggestionColumns = {
    JigyoushaCD_Obj : [],
    MakerCD_Obj : []
};

class MasterNayose extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows:[],
            onEdit:false,
            isModify:false,
            dialogOpen : false,
            dialogOpenSave:false,
        }
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
	    const {dispatch} = this.props;
	    this.getNayoseList();
        dispatch(getJigyoshaList());
        dispatch(resetMainListState());
        dispatch(resetConsigneeListStateNew());

	}
    componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
    componentWillUnmount(){
        const { dispatch} = this.props;
        dispatch(resetMasterNayose());
    }

    /** event handlers **/
    handleClickSave = () =>{
        const {auth, dispatch} = this.props;
        const {rows} = this.state;
        const addRow = _.filter(rows,{isAdd:true});
        const updateRow = _.filter(rows,(row)=>{return row.isChange || row.isUpdateDelete});
        dispatch(setNayoseList({
            addRow,
            updateRow,
            SessionID:auth.SessionID
        }));
    };

    handleClickClear = () =>{
        const {onEdit,isModify} = this.state;
        if(onEdit || isModify){
            this.setState({
                dialogOpen:true
            });
        }
        else{
            this.getNayoseList();
        }
    };

    doClear = () =>{
        this.setState({
            dialogOpen:false
        });
        this.getNayoseList();

    };

    cancelClear = () =>{
        this.setState({
            dialogOpen:false
        });
    };

    handleGetCurrentList = ({rows,addedRows,editRows}) =>{
        const onEdit = (Object.keys(addedRows).length > 0) || (Object.keys(editRows).length > 0);
        const isModify = rows.some(row=>{
            return row.isAdd || row.isChange || row.isUpdateDelete
        });
        this.setState({rows,onEdit,isModify});
    };

    handleClickDL = () =>{
        const {auth, dispatch} = this.props;
        dispatch(fetchCsvMasterNayose({SessionID:auth.SessionID}));
    };

    getNayoseList(){
        const {auth, dispatch} = this.props;
        dispatch(getNayoseList({SessionID:auth.SessionID}));
    }


    render() {
        const {settings,classes} = this.props;
        const {onEdit, isModify,dialogOpen} = this.state;


        const disabled = onEdit || !(isModify);
        const mainButtons = [
            {type:'SAVE',func:this.handleClickSave, disabled},
            {type:'CLEAR',func:this.handleClickClear},
            {type:'DL',func:this.handleClickDL,hasMargin:true},
        ];

        const rows = settings.data;
        suggestionColumns["JigyoushaCD_Obj"] = settings.jigyoshaData.flatMap(
            suggestion =>
            (suggestion.ElectronicReceiptFlg === "1") ?
                {
                    value: suggestion.JigyoushaCD,
                    label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
                    name: suggestion.JigyoushaName,
                }
            : []
        );


        suggestionColumns["MakerCD_Obj"] = settings.jigyoshaData.flatMap(
            suggestion =>
                (suggestion.MakerElectronicReceiptFlg === "1") ?
                    {
                        value: suggestion.JigyoushaCD,
                        label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
                        name: suggestion.JigyoushaName,
                    }
                    : []
        );


        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>名寄せマスタ</h2>
                    </section>
                    <section className="with_button">
                        <div className={classNames(classes.buttonHide,classes.buttonHideLeft)}/>
                        <div className={classNames(classes.buttonHide,classes.buttonHideRight)}/>
                        <MasterTable
                            dataSource={rows}
                            columns={columns}
                            suggestionColumns={suggestionColumns}
                            defaultSorts={[{columnName:'JigyoushaCD',direction:'asc'},{columnName:'MakerCD',direction:'asc'},{columnName:'NohinsakiCD',direction:'asc'}]}
                            getCurrentState={this.handleGetCurrentList}
                        />
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <AlertDialog
                    open={dialogOpen}
                    title={"確認"}
                    text={<span>編集中の内容は破棄されます</span>}
                    okFunction={this.doClear}
                    closeFunction={this.cancelClear}
                />
                <ErrorDialog
                    open={settings.isProcessError}
                />
				<ReloadModal />
                <LogoutModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.masterNayoseSettings,

  };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(MasterNayose);



// WEBPACK FOOTER //
// ./src/routes/master/nayose/index.js